<template>
  <div class="receipt-list">
    <!-- 搜索 -->
    <div class="search">
      <el-form :model="exportForm" ref="exportForm" class="demo-ruleForm">
        <div class="form-row">
          <el-form-item prop="warehouseId" label="仓库名称：">
            <el-select v-model="exportForm.warehouseId" placeholder="请选择仓库" @change="changeWarehouse">
              <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="projectId" label="项目名称：">
            <el-select v-model="exportForm.projectId" placeholder="请选择项目">
              <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="date" label="运单日期：">
            <el-date-picker v-model="exportForm.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="title-container">
      <p class="table-title">物流补登信息</p>
      <div class="upload-return" @click="exportLoginForm('exportForm')">
        <span class="upload-return-img"></span>
        <span>导出</span>
      </div>
    </div>

    <!-- 收货列表 -->
    <div class="table">
      <el-table :data="tableData" style="width: 100%"
        :header-cell-class-name="headerCellClassName">
        <el-table-column v-for="(item, index) in tableTitle" :key="index" :prop="item.prop" :label="item.label"
          :width="item.width" show-overflow-tooltip
          :class-name="item.alignment === 'right' ? `cell-right-align-width` : ''">
        </el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text"
              @click="nullify(scope.row.id)">作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl :total="total" :currentPage="currentPage" :pageSize="pageSize"
          @queryChange="queryChange"></pagination-tpl>
      </div>
    </div>
  </div>
</template>

<script>
import ManualOrder from "models/production/manual-order";
import warehouseMixins from "@/common/mixins/warehouse.js"
import projectMixins from "@/common/mixins/project.js"
import PaginationTpl from "components/base/PaginationTpl";
import { numsToRMBSymbolAndMillimeter, downLoadFileByBlob } from "common/js/util";
export default {
  mixins: [warehouseMixins, projectMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      exportForm: {
        warehouseId: '',
        date: "",
        projectId: '',
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        { label: '仓库名称', prop: 'warehouseName', width: '150', alignment: 'left' },
        { label: '项目名称', prop: 'projectName', width: '', alignment: 'left' },
        { label: '运单日期', prop: 'creatTime', width: '150', alignment: 'left' },
        { label: '货主单号', prop: 'customerOrderCode', width: '150', alignment: 'left' },
        { label: '快递类型', prop: 'expressName', width: '', alignment: 'left' },
        { label: '运单号', prop: '.expressNo', width: '150', alignment: 'left' },
        { label: '到件地址', prop: 'address', width: '150', alignment: 'left' },
        { label: '发货件数', prop: 'shippedNumber', width: '140', alignment: 'right' },
        { label: '运单重量(KG)', prop: 'orderWeight', width: '140', alignment: 'right' },
        { label: '运费', prop: 'logisticIncome', width: '150', alignment: 'right' },
        { label: '备注', prop: 'remarks', width: '150', alignment: 'left' },
      ],
    }
  },

  created() {
    this.initWarehouse()
    this.initManualOrderRecordList()
  },

  methods: {
    /** 
     * @desc 初始化手工单记录列表
    */
    initManualOrderRecordList() {
      let warehouseId = this.exportForm.warehouseId
      let beginDate = this.exportForm.date ? this.exportForm.date[0]:''
      let endDate = this.exportForm.date ? this.exportForm.date[1]:''
      let projectId = this.exportForm.projectId
      let pageNo = this.currentPage
      let data = {
        warehouseId,
        beginDate,
        endDate,
        projectId,
        pageNo,
      }
      ManualOrder.getManualOrderRecordsList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.warehouseName = value.warehouseName;
            obj.creatTime = value.billDate;
            obj.customerOrderCode = value.customerOrderCode;
            obj.projectId = value.projectId;
            obj.projectName = value.projectName;
            obj.expressName = value.expressName;
            obj.expressNo = value.expressNo;
            obj.address = `${value.receiveProvince}${value.receiveCity}${value.receiveCounty}`;
            obj.shippedNumber = value.shippedNumber;
            obj.orderWeight = value.orderWeight;
            obj.logisticIncome = numsToRMBSymbolAndMillimeter(value.logisticIncome);
            obj.remarks = value.remark;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    searchData() {
      this.currentPage = 1;
      this.initManualOrderRecordList();
    },

    reset() {
      this.exportForm.date = ""
      this.exportForm.warehouseId = ""
      this.exportForm.projectId = ""
    },

    /** 
     * @desc 作废
    */
    nullify(id) {
      this.$confirm("作废后，该补登记录将不可再次操作，请确认", "作废", {
        confirmButtonText: "作废",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        ManualOrder.postNullify(id).then(res => {
          if (res.success) {
            this.initManualOrderRecordList();
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      });
    },

    changeWarehouse() {
      let warehouseId = this.exportForm.warehouseId;
      this.exportForm.projectId = ''
      this.initProjectListByWarehouse(warehouseId);
    },

    /**
     * @desc 导出
     */
    exportLoginForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.exportForm.warehouseId
          let beginDate = this.exportForm.date ?this.exportForm.date[0]:""
          let endDate = this.exportForm.date ?this.exportForm.date[1]:""
          let projectId = this.exportForm.projectId
          let data = {
            warehouseId,
            beginDate,
            endDate,
            projectId
          }
          ManualOrder.getExportManualOrder(data).then((res) => {
            downLoadFileByBlob(res)
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex > 6 && columnIndex < 10) {
        return 'right-align'
      }
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initManualOrderRecordList();
    },
  }
}
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/receipt-list.scss";
</style>
